// Module
var code = "<nav class=\"drawer-container\" id=\"drawerContainer\"> <div class=\"drawer-header\"> <button class=\"drawer-close-btn\" ng-click=\"close()\"> <i class=\"glyphicon glyphicon-remove\"></i> </button> </div> </nav>";
// Exports
export default code;